<div class="logomain">
  <figure class="st_logo" routerLink="/dashboard">
    <img src="{{ assetsConst.Logo }}" alt="logo-w" />
  </figure>
  <figure class="rs_logo" routerLink="/dashboard">
    <img src="{{ assetsConst.Logo }}" alt="logo-w" />
  </figure>
  <div class="toggle" (click)="toggleSidenav()">
    <i class="fa-solid fa-x"></i>
  </div>
</div>
<mat-nav-list class="sd_bar">
  <div *ngFor="let item of sideBar">
    <ng-container *ngIf="item.isView || role === userRole.DISPATCHER">
      <ng-container *ngIf="!item.isSubMenu || (item.subMenuItems && item.subMenuItems.length === 0)">
        <mat-list-item [routerLink]="item.path" routerLinkActive="active">
          <figure
            class="sd_cn"
            matTooltip="{{ item.text | translate }}"
            [matTooltipPosition]="tooltipPosition">
            <img src="{{ item.icon | translate }}" alt="images" />
          </figure>
          <div fxFlex="10"></div>
          <div *ngIf="sidenavWidth > 6" class="sidenav-item">
            <h5 class="lead">{{ item.text | translate }}</h5>
          </div>
        </mat-list-item>
      </ng-container>
      <mat-accordion *ngIf="item.isSubMenu || (item.subMenuItems && item.subMenuItems.length > 0)">
        <mat-expansion-panel class="drop_lst_nv">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-list-item
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">
                <figure
                  class="sd_cn"
                  matTooltip="{{ item.text | translate }}"
                  [matTooltipPosition]="tooltipPosition">
                  <img src="{{ item.icon }}" alt="images" />
                </figure>
                <div fxFlex="10"></div>
                <div *ngIf="sidenavWidth > 6" class="sidenav-item">
                  <h5 class="lead">{{ item.text | translate }}</h5>
                </div>
              </mat-list-item>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-container *ngFor="let sub of item.subMenuItems"> 
            <mat-list-item
            *ngIf="sub.isView"
            (click)="toggleSidenav()"
            [routerLink]="sub.path">
              <figure
                class="sd_cn"
                matTooltip="{{ sub.text | translate }}"
                [matTooltipPosition]="tooltipPosition">
                <img src="{{ sub.icon }}" alt="images" />
              </figure>
              <div *ngIf="sidenavWidth > 6" class="sidenav-item">
                <h5 class="lead">{{ sub.text | translate }}</h5>
              </div>
            </mat-list-item>
          </ng-container>
        </mat-expansion-panel>
      </mat-accordion>
    </ng-container>
  </div>
</mat-nav-list>
